<div class="profile-picture-container">
	<input type="file" id="fileInput" (change)="uploadFile($event)" hidden />
	@if (imageUrl) {
		<img [src]="imageUrl" alt="Profile Picture" class="profile-picture" />
	}
	@if (!imageUrl && !isImageLoading) {
		<div class="profile-placeholder"></div>
	}
	@if (isImageLoading) {
		<div class="d-flex align-items-center justify-content-center h-100">
			<mat-spinner
				color="secondary"
				diameter="50"
				mode="determinate"
				[value]="imageLoadingPercent$ | async"
			></mat-spinner>
			<div class="position-absolute">{{ imageLoadingPercent$ | async | number: '1.0-0' }}%</div>
		</div>
	}
	@if (!hideEditButton) {
		<label for="fileInput" class="edit-icon">
			<mat-icon>edit</mat-icon>
		</label>
	}
</div>
